import React from 'react';
import styled from 'styled-components';
import Loader from "react-loader-spinner";
import { AcceptFileFormat } from './acceptFileFormat';

const Title = styled.p`
    white-space: nowrap;
    margin: 0 10px 0 0;
    font-weight: 600;
    color: #333;
`;

const FileLabel = styled.label`
    cursor: pointer;
    padding: 8px 15px;
    border: 1px solid #2d207d;
    border-radius: 5px;
    font-size: 14px;
    background: #fff;
    width: 140px;
    text-align: center;
    :hover{
        border: 2px solid #2d207d;
    }
`;

const Upload = ({ loading, label, onChange, selectedFiles, documentName, placeholder, required, multiple, uploadFileErr }) => {
    let fileName = documentName ? (documentName.slice(0, 10) + '..') 
        : selectedFiles && ((selectedFiles && selectedFiles.length === 1) ? (selectedFiles[0].name && selectedFiles[0].name.slice(0, 10)) + '..' 
            : `${selectedFiles.length} files selected`);
    placeholder = (placeholder && placeholder.length > 10) ? placeholder.slice(0, 10) + '..' : placeholder;
    let defaultLabel = label ? ((label.length > 4) ? label.slice(0, 4) : label) : '';
    return(
        <div className="d-flex align-items-center">
            {label && <Title>{label} {required && <span style={{color: 'red', marginLeft: '2px'}}>*</span>}</Title>}
            <div className="d-flex justify-content-start">
                <div style={{position: 'relative'}}>
                    <FileLabel htmlFor={label} disabled={loading}>
                        {loading ? <Loader type="Oval" color="#2d207d" height={20} width={20} style={{marginLeft: '10px'}} />
                            : (fileName ? fileName : ((placeholder && placeholder.length > 0) ? placeholder : `Upload ${defaultLabel}`))}
                    </FileLabel>
                    <input disabled={loading} style={{opacity: 0, width: '140px', position: 'absolute', left: 0, height: '45px', cursor: 'pointer'}} type="file" id={label} accept={AcceptFileFormat} onChange={onChange} name={label} datamultiplecaption={`${2} files selected`} multiple={multiple} />
                </div>
            </div>
            {uploadFileErr && <p className="text-danger">{uploadFileErr}</p>}
        </div>
    );
};

export default Upload;